const DB_NAME = "products_db";
const DB_VERSION = 1;
let DB;

export default {
  async getDb() {
    return new Promise((resolve, reject) => {
      if (DB) {
        return resolve(DB);
      }
      // console.log("OPENING DB", DB);
      let request = window.indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = (e) => {
        console.log("Error opening db", e);
        reject("Error");
      };

      request.onsuccess = (e) => {
        DB = e.target.result;
        resolve(DB);
      };

      request.onupgradeneeded = (e) => {
        console.log("onupgradeneeded");
        let db = e.target.result;
        let objectStore = db.createObjectStore("products", { keyPath: "SKU" });
        // Create an index to search products by sku. We want to ensure that
        // no two products have the same sku, so use a unique index.
        objectStore.createIndex("SKU", "SKU", { unique: true });
      };
    });
  },
  async deleteProduct(sku) {
    let db = await this.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["products"], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };

      let store = trans.objectStore("products");
      store.delete(sku);
    });
  },
  async getProducts() {
    let db = await this.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["products"], "readonly");
      trans.oncomplete = () => {
        resolve(products);
      };

      let store = trans.objectStore("products");
      let products = [];

      store.openCursor().onsuccess = (e) => {
        let cursor = e.target.result;
        if (cursor) {
          // console.log("cursor", cursor);
          products.push(cursor.value);
          cursor.continue();
        }
      };
    });
  },

  async getProduct(sku) {
    let db = await this.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["products"], "readonly");
      trans.oncomplete = () => {
        resolve(product);
      };

      let store = trans.objectStore("products");
      let product = undefined;

      store.openCursor().onsuccess = (e) => {
        let cursor = e.target.result;
        if (cursor) {
          if (cursor.key == sku) {
            product = cursor.value;
          }
          cursor.continue();
        }
      };
    });
  },

  async saveProduct(product) {
    let db = await this.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["products"], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };

      let store = trans.objectStore("products");
      store.put(product);
    });
  },
};
